<app-header></app-header>
<div style="overflow: hidden;">

    <div class="row intro_content" style="padding:5%;">
        <div class="col-md-6" style="margin: auto 0px;">
            <h1 class="intro_heading">We Help Marketing Agencies Scale</h1>
            <div class="intro_description">
                Since 2010, we've been dedicated to empowering marketing agencies with innovative client reporting
                solutions tailored for growth. By continuously refining our platform based on valuable feedback from
                agencies, we've developed a seamless system that enhances efficiency, transparency, and client
                satisfaction. With fully automated reports, intuitive custom dashboards, and a suite of powerful
                integrations, Agency Analytics simplifies data management, allowing agencies to focus on strategy and
                results. Our mission is to save agencies time, streamline workflows, and provide insightful analytics
                that drive success. Whether you're looking to impress clients, optimize performance, or scale operations
                effortlessly, we deliver the tools you need to stay ahead in the competitive digital landscape.
            </div>
        </div>
        <div class="col-md-6 intro_image">
            <img src="/assets/about_us/about_us.png" alt="Team Photo" width="100%" style="margin-top: 8%;">
        </div>
    </div>

    <div style="padding: 0% 5% 5% 5%;">
        <h2 style="margin: 15px 0px;">What We Do</h2>
        <div class="row video_details">
            <div class="col-md-6" style="text-align: center;">
                <video autoplay muted loop playsinline class="video_data">
                    <source src="assets/about_us/about_us.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="col-md-6 video_data_description">
                With direct integrations that seamlessly connect data from over 80 marketing channels into a single,
                easy-to-use reporting platform, Agency Analytics is transforming the way marketing agencies manage their
                client reporting. By automating data collection, visualization, and reporting, we eliminate the need for
                time-consuming manual processes, allowing agencies to focus on strategy, optimization, and client
                success. Our platform empowers over 7,000 agencies worldwide, helping them streamline workflows, enhance
                productivity, and improve client communication. By reducing the time and effort required to generate
                insightful and visually appealing reports, Agency Analytics enables agencies to maximize billable hours,
                boost efficiency, and scale their operations effortlessly. Whether you manage SEO, PPC, social media, or
                multi-channel campaigns, our comprehensive reporting solution ensures that your agency delivers
                accurate, professional, and data-driven reports with ease.
            </div>

        </div>

    </div>

    <div style="padding: 0% 5%;">
        <h2 style="margin: 15px 0px;">Meet the Team</h2>
        <div style="font-family:Montserrat;text-align: center;padding-bottom: 3%;">
            Our fully remote and collaborative team is made up of some of the best talents from across Canada and
            around the world.
            We are 100% employee-owned and growing fast.
        </div>
        <div>
            <div style="font-family:Montserrat;padding: 10px 0px;">LEADERSHIP</div>
            <div class="profile">
                <div class="profile_image">
                    <img src="assets/ceo.png" alt="Rohan Kulkarni" height="120px" width="120px">
                </div>
                <div class="profile_text">
                    <h3 style="text-align: justify;color: #007BFF;">Rohan Kulkarni</h3>
                    <p id="designation">Founder & CEO</p>
                    <div style="font-family:Montserrat;">
                        Rohan is the co-founder and CEO of AgencyAnalytics, a marketing reporting platform used by more
                        than 7,000 agencies.
                        With experience creating multiple businesses, he thrives on tackling the challenges of
                        sustainable growth and innovation.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <app-our-mission></app-our-mission> -->


    <div class="about_us_data_main">
        <div class="header">
            <h2 style="    font-size: 35px;
            padding: 10px 0px;
            font-weight: 500;">OUR VISION</h2>
            <p>
                Sharkify.ai is driven by a vision to revolutionize AI-driven business solutions, empowering
                organizations to achieve their full potential.
                We aim to integrate cutting-edge artificial intelligence into diverse industries, enabling efficient
                operations, enhanced customer experiences,
                and data-driven decision-making.
            </p>
        </div>
        <div class="content row">
            <div class="section col-md-6">
                <h2>CHALLENGE</h2>
                <p>
                    Organizations often struggle with fragmented systems, data silos, and inefficient workflows,
                    resulting in lost opportunities and stagnated growth.
                    Sharkify.ai aims to bridge these gaps by providing unified AI solutions that enable businesses to
                    unlock the full value of their data and achieve
                    operational excellence.
                </p>
            </div>
            <div class="section col-md-6">
                <h2>SOLUTION</h2>
                <p>
                    Through Sharkify.ai's AI-powered platform, businesses can automate mundane tasks, derive meaningful
                    insights from complex data,
                    and streamline their operations. Our solutions are designed to be adaptable and scalable, ensuring
                    businesses of all sizes can leverage
                    advanced AI technologies for sustainable growth and innovation.
                </p>
            </div>
        </div>
        <div class="features row">
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">FUNCTIONALITY</h2>
                <ul>
                    <li>Intelligent data analysis and visualization</li>
                    <li>AI-driven customer engagement tools</li>
                    <li>Process automation to reduce manual effort</li>
                    <li>Predictive analytics for informed decision-making</li>
                    <li>Seamless integration with existing business systems</li>
                    <li>Personalization to meet unique business needs</li>
                </ul>
            </div>
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">TECHNOLOGY STACK</h2>
                <ul>
                    <li>Python</li>
                    <li>TensorFlow and PyTorch</li>
                    <li>MongoDB</li>
                    <li>AWS (Amazon Web Services)</li>
                    <li>Kubernetes</li>
                    <li>REST and GraphQL APIs</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="about_us_data_main">
        <div class="header">
            <h2 style="    font-size: 35px;
            padding: 10px 0px;
            font-weight: 500;">Our Mission</h2>
            <p>
                At Sharkify.ai, our mission is to empower businesses with intelligent, innovative, and user-friendly AI
                solutions that transform how they operate, grow, and serve their customers. We are committed to enabling
                organizations to harness the power of artificial intelligence to drive sustainable growth, foster
                innovation, and create a lasting impact.
            </p>
        </div>
        <div class="content row">
            <div class="section col-md-6">
                <h2>CHALLENGE</h2>
                <p>
                    Many businesses face challenges in adopting AI due to complex technology, high costs, and lack of
                    expertise. This limits their ability to compete and innovate in a rapidly evolving digital
                    landscape. Sharkify.ai is on a mission to eliminate these barriers, making AI accessible, efficient,
                    and impactful for all.
                </p>
            </div>
            <div class="section col-md-6">
                <h2>SOLUTION</h2>
                <p>
                    Sharkify.ai provides intuitive AI-driven tools and platforms designed for businesses of all sizes.
                    By simplifying AI integration and focusing on real-world applications, we empower companies to
                    unlock new opportunities, optimize their operations, and stay ahead in a competitive market.
                </p>
            </div>
        </div>
        <div class="features row">
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">Values</h2>
                <ul>
                    <li>Innovation: Constantly pushing boundaries to deliver cutting-edge AI solutions.</li>
                    <li>Accessibility: Ensuring AI is easy to use and accessible to every business.</li>
                    <li>Impact: Delivering tangible value and measurable outcomes.</li>

                </ul>
            </div>
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">Goals</h2>
                <ul>
                    <li>Bridge the gap between AI technology and business needs.</li>
                    <li>Create scalable solutions tailored to diverse industries.</li>
                    <li>Continuously improve and innovate to meet emerging challenges.</li>
                    <li>Foster a culture of excellence, growth, and trust.</li>

                </ul>
            </div>
        </div>
    </div>

    <div class="about_us_data_main">
        <div class="header">
            <h2 style="    font-size: 35px;
            padding: 10px 0px;
            font-weight: 500;">Our Strategy</h2>
            <p>
                At Sharkify.ai, our strategy is rooted in delivering impactful AI-driven solutions that align with the
                evolving needs of modern businesses. By focusing on innovation, adaptability, and collaboration, we aim
                to lead the way in creating intelligent systems that empower businesses to achieve their goals
                efficiently and effectively.
            </p>
        </div>
        <div class="content row">
            <div class="section col-md-6">
                <h2>CHALLENGE</h2>
                <p>
                    The rapid pace of technological advancement and shifting market dynamics demand agile and
                    forward-thinking strategies. Many businesses struggle to navigate these changes while staying
                    competitive. Sharkify.ai's strategy is designed to address these challenges by delivering scalable,
                    tailored solutions that enable businesses to innovate and grow sustainably.
                </p>
            </div>
            <div class="section col-md-6">
                <h2>Approach
                </h2>
                <p>
                    We prioritize understanding our clients' unique needs to create tailored solutions that deliver
                    impactful results. Our flexible and adaptable approaches help businesses stay competitive in dynamic
                    markets, while advanced analytics and AI empower smarter, data-driven decisions. Through close
                    collaboration
                </p>
            </div>
        </div>
        <div class="features row">
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">Key Focus Areas</h2>
                <ul>
                    <li>Innovation Leadership: Continuously enhancing our AI capabilities to stay ahead in a competitive
                        landscape.</li>
                    <li>Scalable Solutions: Offering platforms and tools that grow with our clients' businesses.</li>
                    <li>Operational Excellence: Ensuring efficient delivery and reliable performance in all our
                        offerings.</li>
                    <li>Sustainability: Designing solutions that not only drive growth but also align with long-term
                        sustainability goals.</li>
                </ul>
            </div>
            <div class="column col-md-6">
                <h2 style="color: #ff600f;">Our Roadmap</h2>
                <ul>
                    <li>Phase 1: Build and refine AI solutions tailored to diverse industries.</li>
                    <li>Phase 2: Expand global reach and ensure seamless integration across various platforms.</li>
                    <li>Phase 3: Invest in R&D to continue innovating and addressing emerging market needs.</li>
                    <li>Phase 4: Establish Sharkify.ai as the go-to partner for AI transformation worldwide.</li>

                </ul>
            </div>
        </div>
    </div>

</div>
<app-footer></app-footer>